<script setup lang="ts">
import CDashboardSchoolListItemClassroom from '@/presentation/components/dashboard/CDashboardSchoolListItemClassroom.vue'
import type { SchoolMe } from '@/core/domain/school/core/School.ts'
import CBaseBlock from '@/presentation/components/base/CBaseBlock.vue'

defineProps<{
  school: SchoolMe
}>()
</script>

<template>
  <div class="col-span-12">
    <c-base-block
      :title="`${school.name} - ${school.city} (${school.zipCode})`"
      :toggleable="false"
    >
      <!-- List of classrooms   -->
      <div class="grid grid-cols-12 gap-8">
        <c-dashboard-school-list-item-classroom
          v-if="school.classrooms.length == 0"
          :school="school"
          :classroom="null"
          class="col-span-4"
        />
        <c-dashboard-school-list-item-classroom
          v-else
          v-for="classroom in school.classrooms"
          :key="`classroom_${classroom.schoolClassroomId}`"
          :school="school"
          :classroom="classroom"
          class="col-span-4"
        />
      </div>
    </c-base-block>
  </div>
</template>
